import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 查询 ");

const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 重置 ");

const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 编辑 ");

const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 查看 ");

const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 可见 ");

const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 取消可见 ");

const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 数据导出 ");

const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 添加 ");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_10 = /*#__PURE__*/_createTextVNode("接收人员");

const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1);

const _hoisted_12 = /*#__PURE__*/_createTextVNode("已读人员");

const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1);

const _hoisted_14 = /*#__PURE__*/_createTextVNode("未读人员");

const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1);

const _hoisted_16 = /*#__PURE__*/_createTextVNode("点赞人员");

const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 取消 ");

const _hoisted_18 = /*#__PURE__*/_createTextVNode("导出");

import { ref, defineAsyncComponent, computed } from 'vue';
import { useStore } from 'vuex';
import { dateFormat, getVexTableProps } from '@/config';
import { getPlatformNoticeList, deleteNotice, noticeTopping, exportForAsync } from '@/request';
import { exportNotice } from '@/request/api';
import { ElMessageBox, ElMessage } from 'element-plus';
export default {
  name: 'PlatformNotice',

  setup(__props) {
    const AddPlatformNoticeModal = defineAsyncComponent(() => import(
    /* webpackChunkName: 'AddPlatformNoticeModal' */
    './component/AddPlatformNoticeModal.vue'));
    const defaultForm = {
      title: '',
      supInformationTypeId: '',
      status: '',
      author: '',
      supplierNames: '',
      updateTimeStart: '',
      updateTimeEnd: ''
    };
    const form = ref(_objectSpread({}, defaultForm));
    const store = useStore();
    store.dispatch('getNoticeTypeList');
    const userType = computed(() => store.state.user.userType);
    const noticeTypeList = computed(() => store.state.noticeTypeList);
    const showAddModal = ref(false);
    const editData = ref(null);
    const isSee = ref(false);
    const showExportModal = ref(false);
    const exportType = ref([]);
    let total = 0;
    const tableOptions = getVexTableProps({
      checkboxConfig: {
        checkMethod({
          row
        }) {
          return store.state.user.username === row.registerName;
        }

      },
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getPlatformNoticeList(_objectSpread({
              page: page.currentPage,
              rows: page.pageSize
            }, form.value)).then(data => {
              total = data.total;
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      },
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      columns: [{
        type: 'checkbox',
        width: '50px'
      }, {
        title: '状态',
        field: 'statusStr',
        width: '100px'
      }, {
        title: '分类',
        field: 'typeName',
        width: '100px'
      }, {
        title: '标题',
        field: 'title',
        width: '200px',
        showOverflow: true
      }, {
        title: '创建人姓名',
        field: 'author',
        width: '150px'
      }, {
        title: '链接',
        field: 'url',
        width: '250px',
        showOverflow: true
      }, {
        title: '接收团队',
        field: 'supplierNames',
        width: '200px',
        showOverflow: true,
        formatter: ({
          cellValue
        }) => cellValue || '全部团队'
      }, {
        title: '接收人数',
        field: 'receiveCount',
        width: '100px'
      }, {
        title: '已读人数',
        field: 'readCount',
        width: '150px'
      }, {
        title: '未读人数',
        field: 'unReadCount',
        width: '150px'
      }, {
        title: '点赞人数',
        field: 'likeCount',
        width: '150px'
      }, {
        title: '更新时间',
        field: 'updateAt',
        width: '200px'
      }, {
        title: '发布时间',
        field: 'createAt',
        width: '200px'
      }, {
        title: '创建人账号',
        field: 'registerName',
        width: '150px'
      }, {
        title: '操作',
        fixed: 'right',
        width: '350px',
        slots: {
          default: 'operation'
        }
      }]
    });
    const table = ref();
    let exportRow = null;

    function reset() {
      form.value = _objectSpread({}, defaultForm);
      table.value.commitProxy('reload');
    }

    function del() {
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      ElMessageBox.confirm(`是否确认删除${selectRows.length}条信息?`, '删除').then(() => {
        deleteNotice({
          __warn: true,
          __repeat: true,
          supInformationIds: selectRows.map(item => item.supInformationId).join(',')
        }).then(data => {
          if (data.success) {
            ElMessage.success('操作成功!');
            table.value.commitProxy('query');
          }
        });
      });
    }

    function edit(row) {
      isSee.value = false;
      editData.value = row;
      showAddModal.value = true;
    }

    function add() {
      isSee.value = false;
      editData.value = null;
      showAddModal.value = true;
    }

    function see(row) {
      isSee.value = true;
      showAddModal.value = true;
      editData.value = row;
    }

    function topping(row, isTop) {
      noticeTopping({
        supInformationId: row.supInformationId,
        isTop,
        __warn: true,
        __repeat: true
      }).then(data => {
        if (data !== null && data !== void 0 && data.success) {
          ElMessage.success('操作成功!');
          table.value.commitProxy('query');
        }
      });
    }

    function showExport(row) {
      exportRow = row;
      showExportModal.value = true;
      exportType.value = [];
    }

    function exportData() {
      if (!exportType.value.length) {
        ElMessage({
          showClose: true,
          message: '请选择导出范围!',
          type: 'warning'
        });
        return;
      }

      showExportModal.value = false;
      exportForAsync({
        __repeat: true,
        __warn: true,
        types: exportType.value.join(','),
        supInformationId: exportRow.supInformationId,
        modularflag: 'salesmanInformation',
        fileName: '公告资讯',
        count: total,
        methodName: exportNotice.url
      });
    }

    function addSuccess() {
      editData.value = null;
      table.value.commitProxy('reload');
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_alert = _resolveComponent("el-alert");

      const _component_el_form = _resolveComponent("el-form");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_checkbox = _resolveComponent("el-checkbox");

      const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_form, {
        "label-width": "80px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "标题",
              prop: "title"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.title,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.title = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "公告分类"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.supInformationTypeId,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.supInformationTypeId = $event),
                placeholder: ""
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(noticeTypeList), type => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    label: type.text,
                    key: type.id,
                    value: type.id
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "状态"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.status,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.status = $event)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "全部",
                  value: ""
                }), _createVNode(_component_el_option, {
                  label: "已发布",
                  value: "1"
                }), _createVNode(_component_el_option, {
                  label: "保存未发布",
                  value: "2"
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "创建人"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.author,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.author = $event),
                placeholder: "请填写创建人/创建人账号"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "团队名称"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.supplierNames,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.supplierNames = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "开始时间"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: form.value.updateTimeStart,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.updateTimeStart = $event),
                type: "date",
                "value-format": _unref(dateFormat),
                placeholder: "开始时间"
              }, null, 8, ["modelValue", "value-format"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "结束时间"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: form.value.updateTimeEnd,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.value.updateTimeEnd = $event),
                type: "date",
                "value-format": _unref(dateFormat),
                placeholder: "结束时间"
              }, null, 8, ["modelValue", "value-format"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, {
          justify: "end"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            icon: "Search",
            onClick: _cache[7] || (_cache[7] = $event => table.value.commitProxy('reload'))
          }, {
            default: _withCtx(() => [_hoisted_1]),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            icon: "Refresh",
            onClick: reset
          }, {
            default: _withCtx(() => [_hoisted_2]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, {
          justify: "start"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_el_alert, {
              type: "warning",
              title: "注：新增公告资讯将排列在“分管”、“超管”全部置顶的内容后面",
              "show-icon": ""
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_grid, _mergeProps({
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), {
        operation: _withCtx(({
          row
        }) => [row.status !== 1 && !(_unref(userType) === 1 && row.registerType === 2 || _unref(userType) === 2 && row.registerType === 1) ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          icon: "Edit",
          type: "primary",
          onClick: $event => edit(row)
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true), row.status === 1 || _unref(userType) === 1 && row.registerType === 2 || _unref(userType) === 2 && row.registerType === 1 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          icon: "View",
          type: "primary",
          onClick: $event => see(row)
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true), row.isTop === 0 && row.status === 1 && _unref(store).state.user.username === row.registerName ? (_openBlock(), _createBlock(_component_el_button, {
          key: 2,
          type: "success",
          icon: "Top",
          plain: "",
          onClick: $event => topping(row, 1)
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true), row.isTop === 1 && row.status === 1 && _unref(store).state.user.username === row.registerName ? (_openBlock(), _createBlock(_component_el_button, {
          key: 3,
          type: "warning",
          icon: "Close",
          plain: "",
          onClick: $event => topping(row, 0)
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true), row.status === 1 && !(row.registerType === 1 && (row.receiveRange === 1 || _unref(userType) !== 1)) ? (_openBlock(), _createBlock(_component_el_button, {
          key: 4,
          type: "warning",
          icon: "Download",
          onClick: $event => showExport(row)
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true)]),
        tools: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Plus",
          onClick: add
        }, {
          default: _withCtx(() => [_hoisted_8]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "danger",
          icon: "Delete",
          onClick: del
        }, {
          default: _withCtx(() => [_hoisted_9]),
          _: 1
        })]),
        _: 1
      }, 16), _createVNode(_unref(AddPlatformNoticeModal), {
        modelValue: showAddModal.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => showAddModal.value = $event),
        see: isSee.value,
        noticeTypeList: _unref(noticeTypeList),
        editData: editData.value,
        onSuccess: addSuccess
      }, null, 8, ["modelValue", "see", "noticeTypeList", "editData"]), _createVNode(_component_el_dialog, {
        title: "导出范围",
        modelValue: showExportModal.value,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => showExportModal.value = $event),
        width: "300px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[10] || (_cache[10] = $event => showExportModal.value = false)
        }, {
          default: _withCtx(() => [_hoisted_17]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: exportData
        }, {
          default: _withCtx(() => [_hoisted_18]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_checkbox_group, {
          modelValue: exportType.value,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => exportType.value = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_checkbox, {
            label: "1"
          }, {
            default: _withCtx(() => [_hoisted_10]),
            _: 1
          }), _hoisted_11, _createVNode(_component_el_checkbox, {
            label: "2"
          }, {
            default: _withCtx(() => [_hoisted_12]),
            _: 1
          }), _hoisted_13, _createVNode(_component_el_checkbox, {
            label: "3"
          }, {
            default: _withCtx(() => [_hoisted_14]),
            _: 1
          }), _hoisted_15, _createVNode(_component_el_checkbox, {
            label: "4"
          }, {
            default: _withCtx(() => [_hoisted_16]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};